import React from 'react';

const HealthCheckPage: React.FC = () => {
  return (
    <div style={{ padding: 32, textAlign: 'center' }}>
      <h1>Karas Health Check</h1>
      <p style={{ color: 'green', fontSize: '18px' }}>
        ✅ Karas service is up and running!
      </p>
      <div
        style={{
          marginTop: 24,
          padding: 16,
          backgroundColor: '#f5f5f5',
          borderRadius: 8,
        }}
      >
        <p>
          <strong>Service:</strong> Karas Frontend
        </p>
        <p>
          <strong>Status:</strong> Healthy
        </p>
        <p>
          <strong>Timestamp:</strong> {new Date().toISOString()}
        </p>
      </div>
    </div>
  );
};

export default HealthCheckPage;
